/**
 * Short range label for dashboard trigger buttons (e.g. "Mar 18 – Apr 17, 2026").
 */
export function formatCompactDateRangeForDashboard(fromIso: string, toIso: string, timeZone: string): string {
  const a = new Date(`${fromIso}T12:00:00.000Z`)
  const b = new Date(`${toIso}T12:00:00.000Z`)
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return `${fromIso} – ${toIso}`

  const yOpt: Intl.DateTimeFormatOptions = { timeZone, year: 'numeric' }
  const mdOpt: Intl.DateTimeFormatOptions = { timeZone, month: 'short', day: 'numeric' }
  const y1 = new Intl.DateTimeFormat('en-US', yOpt).format(a)
  const y2 = new Intl.DateTimeFormat('en-US', yOpt).format(b)
  const left = new Intl.DateTimeFormat('en-US', mdOpt).format(a)
  const right = new Intl.DateTimeFormat('en-US', mdOpt).format(b)
  if (y1 === y2) return `${left} – ${right}, ${y1}`
  return `${left}, ${y1} – ${right}, ${y2}`
}
